module.exports = __webpack_public_path__ + "static/media/sb.68dff614.webp";